import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';

import { LOGOUT_USER,
  SET_USER, SET_ACTIVE_USER_ID, SET_ACTIVE_USER_TYPE, SET_AUTH_TOKEN,
  GET_ID_GEN, INCREMENT_ID_GEN,
  INCREMENT_FAILED_LOGIN, RESET_FAILED_LOGIN
} from 'redux/actionTypes';

export const logoutUser = () => ({
  type: LOGOUT_USER
});

export const setUser = user => ({
  type: SET_USER,
  payload: user
});

export const setActiveUserId = id => ({
  type: SET_ACTIVE_USER_ID,
  payload: id
});

export const setActiveUserType = id => ({
  type: SET_ACTIVE_USER_TYPE,
  payload: id
});

export const setAuthToken = token => ({
  type: SET_AUTH_TOKEN,
  payload: token
});



/*
export const updateUserFunds = (data) => (dispatch, getState) => {
  axiosClient
    .post('/api/users/funds', data, tokenConfig(getState))
    .then(res => {
      //console.log(res.data);
    })
    .catch(err => console.log(err))
};
*/



export const getIDGen = () => (dispatch, getState) => {
  axiosClient
    .get('/api/id-gens', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_ID_GEN,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const incrementIDGen = (data) => (dispatch, getState) => {
  axiosClient
    .patch('/api/id-gens', data, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: INCREMENT_ID_GEN,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const incrementIDGenSocket = data => ({
  type: INCREMENT_ID_GEN,
  payload: data
});



export const incrementFailedLogin = () => ({
  type: INCREMENT_FAILED_LOGIN
});

export const resetFailedLogin = () => ({
  type: RESET_FAILED_LOGIN
});

export * from './customerActions';
export * from './productActions';
export * from './categoryActions';
export * from './employeeActions';
export * from './vendorActions';
export * from './salesOrderActions';
export * from './processActions';
export * from './expenseActions';
//export * from './expenseTypeActions';
//export * from './fundTransferActions';
export * from './newSalesOrderActions';